export default __webpack_public_path__ + "static/media/679.fc37bf3a.png";